import {apiAction} from './helper';

export const GET_MOVEMENT_RETENTION_PERIODS = apiAction('GET_MOVEMENT_RETENTION_PERIODS');
